import $ from 'jquery';

import FontFaceObserver from 'fontfaceobserver/fontfaceobserver';

const $head = $('head');

const font = {
    loadAll: () => {
        $head.append(`<style>
        @font-face {
            font-family: 'li-regular-temp';
            src: url(https://s.ampmake.com/www/font2022/LiciumFont2022-Regular.woff2) format("woff2"), url(https://s.ampmake.com/www/font2022/LiciumFont2022-Regular.woff) format("woff");
        }
        @font-face {
            font-family: 'li-medium-temp';
            src: url(https://s.ampmake.com/www/font2022/LiciumFont2022-Medium.woff2) format("woff2"), url(https://s.ampmake.com/www/font2022/LiciumFont2022-Medium.woff) format("woff");
        }
</style>`);
        const fontFaceObserverRegular = new FontFaceObserver('li-regular-temp');
        const fontFaceObserverBold = new FontFaceObserver('li-medium-temp');
        fontFaceObserverRegular
            .load('0')
            .then(() => {
                $head.append(`<style>
                @font-face {
                    font-family: 'li-regular';
                    src: url(https://s.ampmake.com/www/font2022/LiciumFont2022-Regular.woff2) format("woff2"), 
                    url(https://s.ampmake.com/www/font2022/LiciumFont2022-Regular.woff) format("woff");
                }
            </style>`);
            })
            .catch((e: any) => {
                console.log(e);
            });
        fontFaceObserverBold
            .load('0')
            .then(() => {
                $head.append(`<style>
                @font-face {
                    font-family: 'li-medium';
                    src: url(https://s.ampmake.com/www/font2022/LiciumFont2022-Medium.woff2) format("woff2"), 
                    url(https://s.ampmake.com/www/font2022/LiciumFont2022-Medium.woff) format("woff");
                }
            </style>`);
            })
            .catch((e: any) => {
                console.log(e);
            });
    }
};
font.loadAll();

export default font;
